import angular from 'angular';
import uiRouter from 'angular-ui-router';
import jobsComponent from './jobs.component';

let jobsModule = angular.module('app.containers.jobs', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('jobs', {
      url: '/jobs',
      template: '<jobs></jobs>'
    });
})

.component('jobs', jobsComponent);

export default jobsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/jobs/jobs.js
 **/